// 在您的某个store中（例如mainStore或创建一个新的fileStore）
import { defineStore } from 'pinia'

interface FileState {
  pendingHomeFiles: File[]
  uploadedFile: any
  isUploading: boolean
  uploadError: string | null
}

export const useFileStore = defineStore('file', {
  state: (): FileState => ({
    pendingHomeFiles: [],
    uploadedFile: null,
    isUploading: false,
    uploadError: null
  }),
  
  actions: {
    setPendingHomeFiles(files: File[]) {
      this.pendingHomeFiles = files
    },

    takePendingHomeFiles(): File[] {
      const files = this.pendingHomeFiles
      this.pendingHomeFiles = []
      return files
    },

    setUploadedFile(fileInfo: any) {
      this.uploadedFile = fileInfo
    },
    
    setUploading(status: boolean) {
      this.isUploading = status
    },
    
    setError(error: string | null) {
      this.uploadError = error
    },
    
    clearFile() {
      this.uploadedFile = null
      this.uploadError = null
    }
  }
})